import moment from 'moment';

export const GroupBodyTemplate = ({ groupName }: { groupName: string }) => (
  <div>{groupName || '-'}</div>
);

export const DiabetTypeBodyTemplate = ({
  diabetType,
}: {
  diabetType: string | null;
}) => <div>{diabetType || '-'}</div>;

export const GenderBodyTemplate = ({ gender }: { gender: string }) => {
  let resultGender;
  if (gender) {
    resultGender = gender === 'MALE' ? 'Мужской' : 'Женский';
  }
  return <div>{resultGender || '-'}</div>;
};

export const WeightBodyTemplate = ({ weight }: { weight: number }) => (
  <div>{weight ? `${weight} кг` : '-'}</div>
);

const calculateAgeSuffixWord = (age: number) => {
  if (age % 10 === 1 && age % 100 !== 11) {
    return 'год';
  }
  if (age % 10 >= 2 && age % 10 <= 4 && (age % 100 < 10 || age % 100 >= 20)) {
    return 'года';
  }
  return 'лет';
};

export const AgeBodyTemplate = ({ birthDate }: { birthDate: string }) => {
  const age = birthDate
    ? Math.abs(moment(birthDate).diff(moment(), 'years'))
    : undefined;
  return <div>{age ? `${age} ${calculateAgeSuffixWord(age)}` : '-'}</div>;
};

export const GlucoseRangeBodyTemplate = ({
  glucoseRange,
}: {
  glucoseRange: { min: number; max: number };
}) => <div>{`${glucoseRange.min} - ${glucoseRange.max} м/моль`}</div>;

export const GlucometerSerialNumberBodyTemplate = ({
  glucometerSerialNumber,
}: {
  glucometerSerialNumber: string;
}) => <div>{glucometerSerialNumber ?? '-'}</div>;

export const AppBodyTemplate = ({
  bundleId,
}: {
  bundleId: 'roche.ios.satellite' | 'roche.android.satellite';
}) => (
  <div>
    {bundleId === 'roche.android.satellite'
      ? 'Android'
      : bundleId === 'roche.ios.satellite'
      ? 'iOS'
      : '-'}
  </div>
);

export const AppVersionBodyTemplate = ({
  appVersion,
}: {
  appVersion: string;
}) => <div>{appVersion ?? '-'}</div>;
